import css from "./ContinueButton.css";
import StyledButton from "../common/StyledButton";
import React from "react";
import PropTypes from "prop-types";
import Icon from 'SF/MaterialIcon';

function ContinueButton(props) {
  return (
      <div className={css['content-button-div']}>
        <StyledButton aria-disabled={props.disabled} className={css['content-button']} onClick={!props.disabled ? props.onClick : null}>
          <span>
            CONTINUE
            <Icon icon='keyboard_arrow_right' aria-hidden='true'/>
          </span>
        </StyledButton>
      </div>
  );
}

ContinueButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default ContinueButton;
